window.addEventListener('load', function(){
    hearderRight();
});

// PC - 헤더 장바구니, 마이페이지
function hearderRight(){
    const myBtn = document.querySelector(".icon-wrap .m-header__account");
    const cartBtn = document.querySelector(".icon-wrap .m-cart-icon-bubble");
    const categoryUl = document.querySelector(".icon-wrap");

    myBtn.addEventListener("mouseenter", function () {
        categoryUl.style.setProperty("--hover-left", "4px");
    });

    cartBtn.addEventListener("mouseenter", function () {
        categoryUl.style.setProperty("--hover-left", "31px");
    });
}

const observer = new MutationObserver(() => {
  const isMenuOpen = document.querySelector('.m-menu-drawer.open');
  const mobileHeader = document.querySelector('.m-header.stuck header.m-header__mobile');

  if (mobileHeader) {
    if (isMenuOpen) {
      mobileHeader.classList.add('active');
    } else {
      mobileHeader.classList.remove('active');
    }
  }
});

// .m-menu-drawer 요소 감시
const menuDrawer = document.querySelector('.m-menu-drawer');
if (menuDrawer) {
  observer.observe(menuDrawer, { attributes: true, attributeFilter: ['class'] });
}


class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close"
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyEnabled = "true" === this.dataset.sticky || !1;
    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck"
    };
    this.init();
  }

  init() {
    this.transparentHeader = this.domNodes &&
      this.domNodes.headers[0] &&
      "true" === this.domNodes.headers[0].dataset.transparent;
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
    this.transparentHeader && this.innerWidth > 1280
      ? this.domNodes.headerWrapper &&
        this.domNodes.headerWrapper.classList.add("transparent-on-top")
      : this.domNodes.headerWrapper &&
        this.domNodes.headerWrapper.classList.remove("transparent-on-top");
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    Shopify.designMode &&
      (MinimogTheme = MinimogTheme || {}),
      MinimogTheme &&
        MinimogTheme.Wishlist &&
        MinimogTheme.Wishlist.updateWishlistCount();
  }

  handleSticky() {
    let s = 20;
    document
      .querySelectorAll(".shopify-section-group-header-group")
      .forEach((e) => {
        e.classList.contains("m-section-header") || (s += e.offsetHeight);
      });
    const e = document.querySelector(".m-topbar");
    e && (s += e.offsetHeight);
    if (!this.stickyEnabled) return;
    let t = 0;
    window.addEventListener("scroll", () => {
      const e = window.scrollY;
      if (e <= s)
        return (
          this.classList.remove(this.classes.scrollUp, this.classes.stuck),
          void (this.transparentHeader &&
            this.innerWidth > 1279 &&
            this.domNodes.headerWrapper &&
            this.domNodes.headerWrapper.classList.add("transparent-on-top"))
        );
      this.classList.add(this.classes.stuck);

      // 수정된 부분: scroll-down 제거
      if (e < t && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        this.classList.add(this.classes.scrollUp);
        this.transparentHeader &&
          this.innerWidth > 1279 &&
          this.domNodes.headerWrapper &&
          this.domNodes.headerWrapper.classList.remove("transparent-on-top");
      }

      t = e;
    });
  }
}

customElements.define("m-header", MHeader);
